import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../../../NotFound'

import { AbilityContext } from '../../../../components/Ability'
import { isAllowConnectPlatform } from '../../../../constants/user'
import { useUser } from '../../../../hooks/useUser'
import ChatIntegrationsListPage from './Features/ChatIntegrationsList'
import FacebookPagesLists from './Features/FacebookPagesLists'

const ChatIntegrationsPage = () => {
  const ability = useContext(AbilityContext)
  const { user } = useUser()
  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('read', 'Setting') && isAllowConnectPlatform(user) ? (
            <ChatIntegrationsListPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/pages"
        element={
          ability.can('manage', 'Setting') ? (
            <FacebookPagesLists />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default ChatIntegrationsPage
